import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import {ActivatedRoute} from "@angular/router";
import { style, animate } from '@angular/animations';

@Component({
  selector: 'app-tandenborstels-page',
  templateUrl: './tandenborstels-page.component.html',
  styleUrls: ['./tandenborstels-page.component.scss']
})
export class TandenborstelsPageComponent implements OnInit {

  news_blocks = [];
  content_blocks = [];
  nav_background_class = 'none';


  productsBNL = [
    {
      name: 'Philips Sonicare 3100',
      img: '../../../assets/images/tandenborstels/philips_3100_handle.png',
      modes: 1,
      intensities : 1,
      sensor: true,
      plaque: '3x meer',
      indicator: true,
      app: false,
      adjust: false,
      battery: '3 weken',
      link: 'HX3673/13'
    },
    {
      name: 'Philips Sonicare ProtectiveClean',
      img: '../../../assets/images/tandenborstels/philips_protective_clean_handle.png',
      modes: 2,
      intensities : 2,
      sensor: true,
      plaque: '7x meer',
      indicator: true,
      app: false,
      adjust: false,
      battery: '3 weken',
      link: '881680724030'
    },
    {
      name: 'Philips Sonicare ExpertClean',
      img: '../../../assets/images/tandenborstels/philips_expert_clean_handle.png',
      modes: 3,
      intensities : 3,
      sensor: true,
      plaque: '10x meer',
      indicator: true,
      app: true,
      adjust: false,
      battery: '3 weken',
      link: 'HX9641/01'
    },
    {
      name: 'Philips Sonicare DiamondClean Smart',
      img: '../../../assets/images/tandenborstels/philips_diamondclean_smart_handle.png',
      modes: 5,
      intensities : 5,
      sensor: true,
      plaque: '10x meer',
      indicator: true,
      app: true,
      adjust: false,
      battery: '3 weken',
      link: '881994413030'
    },
    {
      name: 'Philips Sonicare Prestige',
      img: '../../../assets/images/tandenborstels/philips_prestige_handle.png',
      modes: 5,
      intensities : 5,
      sensor: true,
      plaque: '20x meer',
      indicator: true,
      app: true,
      adjust: true,
      battery: '3 weken',
      link: ''
    }
  ]


  reqsDE = [
    'Plaque-Entfernung bis zu',
    'Bürstenbewegungen/Min.',
    'Anzahl Putzprogramme',
    'Intensitätsstufen',
    'Sonicare App',
    '2-Minuten-Timer',
    'Akustischer Quadranten-Timer',
    'Nutzungdauer in Wochen',
    'Innovatives Ladeglas mit Induktionstechnologie',
    'Drucksensor',
    'Scheuersensor',
    'SenseIQ Technologie für dynamische Anpassung der Intensität'
  ]

  productsDE = [
    {
      name: 'Prestige 9900',
      img: '../../../assets/images/tandenborstels/philips-prestige-9900.png',
      plaque: '20x mehr',
      burstenbewegungen: '62.000',
      anzahl: '5',
      intensitatsstufen: '3',
      app: true,
      timer: true,
      akustischer: true,
      nutzungdauer: 'Bis zu 2',
      ladeglas: true,
      drucksensor: true,
      scheuersensor: true,
      senseIQ: true,
      link: 'HX9992/11'
    },
    {
      name: 'Diamond Clean Smart',
      img: '../../../assets/images/tandenborstels/philips_diamondclean_smart_handle.png',
      plaque: '10x mehr',
      burstenbewegungen: '62.000',
      anzahl: '5',
      intensitatsstufen: '3',
      app: true,
      timer: true,
      akustischer: true,
      nutzungdauer: 'Bis zu 2',
      ladeglas: true,
      drucksensor: true,
      scheuersensor: false,
      senseIQ: false,
      link: 'HX9913/17'
    },
    {
      name: 'ExpertClean 7500',
      img: '../../../assets/images/tandenborstels/philips-expert-clean-7500.png',
      plaque: '10x mehr',
      burstenbewegungen: '62.000',
      anzahl: '4',
      intensitatsstufen: '3',
      app: true,
      timer: true,
      akustischer: true,
      nutzungdauer: 'Bis zu 3',
      ladeglas: false,
      drucksensor: true,
      scheuersensor: false,
      senseIQ: false,
      link: 'HX9691/02'
    },
    {
      name: 'Protective Clean 4700',
      img: '../../../assets/images/tandenborstels/philips-protective-clean-4700.png',
      plaque: '7x mehr',
      burstenbewegungen: '62.000',
      anzahl: '2',
      intensitatsstufen: '3',
      app: false,
      timer: true,
      akustischer: true,
      nutzungdauer: 'Bis zu 2',
      ladeglas: false,
      drucksensor: true,
      scheuersensor: false,
      senseIQ: false,
      link: 'HX6483/52'
    },
    {
      name: 'For Kids Connected',
      img: '../../../assets/images/tandenborstels/philips-for-kids-connected.png',
      plaque: '75% mehr',
      burstenbewegungen: '62.000',
      anzahl: '2',
      intensitatsstufen: '-',
      app: true,
      timer: true,
      akustischer: true,
      nutzungdauer: 'Bis zu 2',
      ladeglas: false,
      drucksensor: false,
      scheuersensor: false,
      senseIQ: false,
      link: 'HX6322/04'
    },
  ]


  fadeInBottom = [
    style({opacity: 0, transform: 'translateY(30px)'}),
    animate('1000ms cubic-bezier(0.35, 0, 0.25, 1)', style({opacity: 1, transform: 'translateY(0px)'}))
  ];

  constructor(public dataService: DataService) { }

  ngOnInit() {
    // TODO: the navbar seems to render more the just the navbar, this makes it confusing
    // if( this.dataService.main_country === 'AU' ){
    //  this.nav_background_class = 'dark--au';
    // }
    if (this.dataService.main_country === 'NL' && this.dataService.main_brand !== 'AVENT') {
      this.nav_background_class = 'dark--eu';
    }
    if (!!this.dataService.home_content_blocks && this.dataService.home_content_blocks.length > 0) {
      this.content_blocks = this.dataService.home_content_blocks;
    } else {
      this.load_page_data('HOME', 'content_blocks', 999);
    }
    if (!!this.dataService.news_available && this.dataService.news_count_home > 0) {
      this.load_page_data('NEWS', 'news_blocks', this.dataService.news_count_home);
    }

  }

  scroll_to(target) {
    document.querySelector(target).scrollIntoView({
      behavior: 'smooth'
    });
  }

  scroll_to_slide(target) {
    document.querySelector(target).scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'start',
    });
  }

  load_page_data(page_name, col_name, max_blocks) {
    this.dataService.get_page_content(page_name).subscribe(page => {
      if (!!page && !!page.sections && page.sections.length > 0) {
        this[col_name] = [];
        for (let section of page.sections) {
          let sec = section;
          try {
            let sec = JSON.parse(section);
          } catch (e) {
          }
          if (this[col_name].length < max_blocks) {
            this[col_name].push(sec);
          }
        }
      } else {
        this[col_name] = [];
      }
    }, err => {
      this[col_name] = [];
    });
  }
}


// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/tandenborstels-page/tandenborstels-page.component.ts